import { useLDClient } from '@launchdarkly/react-sdk';
import { legacyDashCaseObjectKeysToCamelCase } from 'integrations/launchDarkly/impl/backwardCompatibilityUtils';
import { LaunchDarklyGlobalFeatureFlags } from 'integrations/launchDarkly/legacy/LaunchDarklyGlobalFeatureFlags.types';
import { LaunchDarklyGlobalFlagsContext } from 'integrations/launchDarkly/providers/LaunchDarklyGlobalFlagsContext';
import { useGlobalDarklyMock } from 'integrations/launchDarkly/legacy/useDarklyMock';
import { useEffect, useState } from 'react';

const NO_FLAGS = {} as LaunchDarklyGlobalFeatureFlags;

/**
 * @deprecated use import from "@oc/darkly/global" instead
 */
export const useDarklyGlobal = (): LaunchDarklyGlobalFeatureFlags => {
  const client = useLDClient(LaunchDarklyGlobalFlagsContext);

  const [flags, setFlags] = useState(() => {
    if (!client.isReady()) {
      return {} as LaunchDarklyGlobalFeatureFlags;
    }
    return legacyDashCaseObjectKeysToCamelCase<LaunchDarklyGlobalFeatureFlags>(client.allFlags() ?? {});
  });

  useEffect(() => {
    function updateFlags() {
      setFlags(legacyDashCaseObjectKeysToCamelCase<LaunchDarklyGlobalFeatureFlags>(client.allFlags() ?? {}));
    }
    if (!client.isReady()) {
      client.waitForInitialization().then((e) => {
        updateFlags();
      });
      return;
    }
    if (client) {
      client.on('change', updateFlags);
    }
    return () => {
      if (client) {
        client.off('change', updateFlags);
      }
    };
  }, [client]);

  const ocFlags = flags ?? NO_FLAGS;

  const mockedFlags = useGlobalDarklyMock();

  if (mockedFlags.enabled) {
    return mockedFlags.flags;
  }
  return ocFlags;
};
